<template>
  <div>
    <h3>Kedves Párok!</h3>

    <p>
      Szeretettel hívunk bennetek idén is a Házasság Hete eseményeire "<i>Hűség, drága kincsem!</i>" mottóval.
    </p>

    <p class="right-align">HH Team</p>

    <h2>Előadás</h2>
    <div class="list-wrapper">
      <p>
        <strong>Kritikus pontok, fejlődési lehetőségek a házasságban:</strong>
        <br>Kígyóssy Örs és Andi
      </p>
      <p>
        <strong>Nagymaros, Szent Márton Közösségi Ház</strong>
        <br> február 1. vasárnap délután 16.00
      </p>

      <p>
        Gyerekvigyázás lesz az előadás alatt, ha szeretnéd hozni gyermekedet, kérjük jelezd a
       <a href="mailto:marosvet75 [kukac] gmail.com">marosvet75 [kukac] gmail.com</a> címre küldött e-maillel.
      </p>
    </div>

    <h2>Egy este "kettesben"</h2>
    <div class="list-wrapper">
      <p>
        Töltsetek egy estét kettesben, beszélgetve! Az ehhez szükséges segítő kérdéseket megtalálod a munkafüzetben - sekrestye, könyvtár - vagy a honlapon.
      </p>
    </div>

    <h2>"Hűség séta"</h2>
    <div class="list-wrapper">
      <p>
        <strong>Nagymaros, Római Katolikus Templom</strong>
        <br> február 10. kedd este 19.00
      </p>

      <p>
        Részletek a helyszínen. Ilyen még nem volt, ne féljetek, gyertek!
      </p>
    </div>

    <h2>Házassági fogadalom megújítása</h2>
    <div class="list-wrapper">
      <p>
        <strong>Nagymaros, Római Katolikus Templom</strong>
        <br> február 15. vasárnap 9.30, záró szentmise
      </p>
    </div>

    <h2>Gyertyafényes vacsora</h2>
    <div class="list-wrapper">
      <p>
        Idén is szervezünk gyertyafényes vacsorát, kérünk jelezzétek részvételi szándékotokat a 
        <a href="mailto:marosvet75 [kukac] gmail.com">marosvet75 [kukac] gmail.com</a> címre küldött e-maillel, legkésőbb február 10-ig.
      </p>
      <p>
        <strong>Nagymaros, Szent Márton Közösségi Ház</strong>
        <br> február 13. péntek este 19.00
      </p>
    </div>

    <!--h2>Országos programajánló</h2>
    <div class="list-wrapper ads">
      <p>
        <a href="https://www.hazassaghete.hu/programok/viharallo-szerelem-3/">Viharálló szerelem</a> (Felsőgöd)
      </p>
      <p>
        <a href="https://www.hazassaghete.hu/programok/ujra-kettesben/">Újra kettesben</a> (Bp. 5. kerület)
      </p>
      <p>
        <a href="https://www.hazassaghete.hu/programok/torespontok-menten-nem-pillanatragasztoval/">Töréspontok mentén, nem pillanatragasztóval</a> (Online)
      </p>
      <p>
        <a href="https://www.hazassaghete.hu/programok/oszinten-a-hazassagrol-paratlan-beszelgetes-kozismert-parokkal-2/">Őszintén a házasságról</a> (Bp. 8. kerület)
      </p>
      <p>
        <a href="https://www.hazassaghete.hu/programok/2441/">Az AI és a szerelem</a> (Bp. 11. kerület)
      </p>
      <p>
        <a href="https://www.hazassaghete.hu/programok/minden-madar-tarsat-valaszt-valoban-ismerkedes-es-parvalasztas-egykor-es-ma/">Minden Madár Társat Választ…</a> (Bp. 8. kerület)
      </p>
      <p>
        <a href="https://www.hazassaghete.hu/programok/zaro-szentmise-hazassag-hete-2025/">Országos záró szentmise.</a> <span>(Bp. 5. kerület)</span>
      </p>
    </div-->
  </div>
</template>

<script>
  export default {
    name: 'main'
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .ads p {
    display: flex;
    justify-content: space-between;

    a {
      display: inline-block;
      margin-right: 10px;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
</style>